import { Component, OnInit } from '@angular/core';
import { Routes } from '@huge-monorepo/portal/config';

@Component({
  selector: 'app-bottom-navbar',
  templateUrl: './bottom-navbar.component.html',
  styleUrls: ['./bottom-navbar.component.scss'],
})
export class BottomNavbarComponent implements OnInit {
  navRoutes: any[] = [];

  constructor(private routes: Routes) {}

  ngOnInit() {
    this.navRoutes.push(
      {
        order: 1,
        routerLink: [this.routes.Home],
        url: this.routes.Home,
        src: 'assets/icon/dashboard.svg',
        label: 'Home',
      },
      // {
      //   order: 2,
      //   routerLink: [this.routes.CDR],
      //   url: this.routes.CDR,
      //   src: "assets/icon/reports.svg",
      //   label: "CDR",
      // },
      {
        order: 3,
        routerLink: [this.routes.KeepAlive],
        url: this.routes.KeepAlive,
        src: 'assets/icon/devices.svg',
        label: 'Keep Alive',
      },
      // {
      //   order: 4,
      //   routerLink: [this.routes.Mikrotik],
      //   url: this.routes.Mikrotik,
      //   src: "assets/icon/reports.svg",
      //   label: "Mikrotik",
      // },
      // {
      //   order: 5,
      //   routerLink: [this.routes.Relay],
      //   url: this.routes.Relay,
      //   src: "assets/icon/reports.svg",
      //   label: "Relay",
      // },
    );
  }
}
